import { RetrieveLPResult } from '@telegram-apps/bridge';

let theme: object | null = null;

const color = [
  "#d63f38",
  "#08aad2",
  "#f89256",
  "#69ae34",
  "#dfb52c",
  "#8c8c94",
  "#fe6e73",
]

export const getTheme = (lp: RetrieveLPResult | null) => {
  if (!lp) {
    return {};
  }
  if (theme) {
    return theme;
  } else {
    const tp = lp.tgWebAppThemeParams;
    theme = {
      color, 
      backgroundColor: tp.bg_color,
      legend: {
        textStyle: {
          color: tp.text_color,
        },
        icon: 'circle',
        backgroundColor: tp.bg_color,
      },
      tooltip: {
        textStyle: {
          color: tp.text_color,
        },
        backgroundColor: tp.bg_color,
      },
    };
    return theme;
  }
};
